import actionTypes from '../constants/action-types';

const status = (state = null, action) => {
  if (action.type !== actionTypes.SET_PUBLISHING_STATUS) return state;
  return action.payload.publishingStatus;
};

export default status;
